import script from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=1af8d424&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af8d424"]])

export default __exports__